module.exports = __webpack_public_path__ + "img/05.18014633.gif";